/*-----------------------------------------------------------------
- Home
-----------------------------------------------------------------*/

export default {
    title    : 'Ev',
    watch_now: 'izle şimdi',
    discover : {
        link: 'Daha fazla bilgi edin',
    },
    discover_power: {
        unlock_text: 'Başsız Yazılımın Gücünü Açığa Çıkarın',
        button     : 'Şimdi başla!',
    },
    articles: {
        title   : 'En son makaleler',
        author  : 'Yazar',
        see_blog: 'Blog\'a Bakın',
        min_read: 'dakika okuma',
    },
};
